import {
  companyConstants,
} from '../constants/companyConstants';

let localCompany = sessionStorage.getItem('company');

if (localCompany !== undefined && localCompany !== 'undefined') {
  localCompany = JSON.parse(sessionStorage.getItem('company'));
}

let initialState = {};
if (localCompany) {
  initialState = {
    company: localCompany,
    requesting: false,
  };
} else {
  initialState = {
    requesting: true,
  };
}

export default function company(state = initialState, action) {
  switch (action.type) {
    case companyConstants.GET_COMPANY_REQUEST:
      return {
        requesting: true,
      };
    case companyConstants.GET_COMPANY_SUCCESS:
      return {
        requesting: false,
        company: action.company,
      };
    case companyConstants.GET_COMPANY_FAILURE:
      return {
        requesting: false,
      };
    case companyConstants.SET_COMPANY:
      return {
        company: action.company,
      };
    case companyConstants.UNSET_COMPANY:
      return {};
    default:
      return state;
  }
}
